export default __webpack_public_path__ + "static/media/sea-plants.4e246d784c7252d760b5053489596533.svg";